import { useBackend } from '@/src/providers/BackendProvider'
import React, { useMemo } from 'react'
import AccountPaper from '@/components/Account/AccountPaper'
import { Typography } from '@evocolabs/orkaui'
import i18n from 'i18next'
import k from '@/src/i18n/keys'
import SkeletonOrder from '@/components/Account/SkeletonOrder'
import NoOrder from '@/components/Account/MyOrders/OrderStatus/NoOrder'
import StatusCard from '@/components/Account/MyOrders/OrderStatus/StatusCard'
import styles from '@/src/components/scss/Account/OrderStatus.module.scss'
import NoOrderMobile from '@/components/Account/MyOrders/OrderStatus/NoOrderMobile'

function OrderStatus({ setWindow, setIndex }) {
  const { orderDetails } = useBackend()
  const res = useMemo(() => {
    if (orderDetails.results.error === 'no such user in platform') {
      return (
        <div>
          <AccountPaper className={styles.title}>
            <Typography variant="T1">{i18n.t(k.MY_ORDERS)}</Typography>
          </AccountPaper>
          <AccountPaper
            style={{
              display: 'flex',
              flexDirection: 'column-reverse',
              marginTop: 16
            }}
          >
            <SkeletonOrder style={{ marginTop: 16 }} />
          </AccountPaper>
          <AccountPaper
            style={{
              display: 'flex',
              flexDirection: 'column-reverse',
              marginTop: 16
            }}
          >
            <SkeletonOrder style={{ marginTop: 16 }} />
          </AccountPaper>
        </div>
      )
    } else {
      if (orderDetails.results.filter((x) => x.infos.status_id).length === 0) {
        return <NoOrder />
      } else {
        return (
          <div>
            <AccountPaper className={styles.title}>
              <Typography variant="T1">{i18n.t(k.MY_ORDERS)}</Typography>
            </AccountPaper>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {orderDetails.results.map((item, index) => {
                if (
                  item.infos.status_id !== 0 &&
                  item.infos.status_id !== null
                ) {
                  return (
                    <StatusCard
                      setWindow={setWindow}
                      setIndex={setIndex}
                      index={index}
                      key={index}
                    />
                  )
                }
                return null
              })}
            </div>
          </div>
        )
      }
    }
  }, [orderDetails.results])
  return <div>{res}</div>
}

function OrderStatusMobile({ setWindow, setIndex }) {
  const { orderDetails } = useBackend()
  const res = useMemo(() => {
    if (orderDetails.results.length === 0) {
      return <NoOrderMobile />
    } else {
      return (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {orderDetails.results.map((item, index) => {
              if (item.infos.status_id !== 0 && item.infos.status_id !== null) {
                return (
                  <StatusCard
                    setWindow={setWindow}
                    index={index}
                    setIndex={setIndex}
                  />
                )
              }
              return null
            })}
          </div>
        </>
      )
    }
  })
  return <>{res}</>
}

export { OrderStatus, OrderStatusMobile }
